"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _LegalConsent = require("lead-flows-ui/constants/LegalConsent");

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var GDPROptions =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(GDPROptions, _PureComponent);

  function GDPROptions() {
    (0, _classCallCheck2.default)(this, GDPROptions);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GDPROptions).apply(this, arguments));
  }

  (0, _createClass2.default)(GDPROptions, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowFormEditor." + suffix;
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return [{
        text: _I18n.default.text(this.langKey('formGDPRSelector.options.none')),
        value: _LegalConsent.LegalConsentOptions.NONE
      }, {
        text: _I18n.default.text(this.langKey('formGDPRSelector.options.consent')),
        help: _I18n.default.text(this.langKey('formGDPRSelector.options.consentHelp')),
        value: _LegalConsent.LegalConsentOptions.IMPLICIT_CONSENT
      }, {
        text: _I18n.default.text(this.langKey('formGDPRSelector.options.consentComm')),
        help: _I18n.default.text(this.langKey('formGDPRSelector.options.consentCommHelp')),
        value: _LegalConsent.LegalConsentOptions.SEPERATE_CONSENT
      }, {
        text: _I18n.default.text(this.langKey('formGDPRSelector.options.legitimate')),
        help: _I18n.default.text(this.langKey('formGDPRSelector.options.legitimateHelp')),
        value: _LegalConsent.LegalConsentOptions.LEGITIMATE_INTEREST
      }];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onChange = _this$props.onChange,
          onEdit = _this$props.onEdit;
      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('formGDPRSelector.header')
        }),
        tooltip: _react.default.createElement(_FormattedHTMLMessage.default, {
          message: this.langKey('formGDPRSelector.tooltip')
        })
      }, _react.default.createElement("div", {
        className: "form-field"
      }, _react.default.createElement(_UIFlex.default, {
        align: "stretch",
        justify: "between",
        direction: "row",
        wrap: "nowrap"
      }, _react.default.createElement(_UIBox.default, {
        className: "dyno-editor__gdpr-selector-container",
        grow: 1
      }, _react.default.createElement(_UISelect.default, {
        menuWidth: "auto",
        onChange: onChange,
        options: this.getOptions(),
        value: value
      })), value === _LegalConsent.LegalConsentOptions.NONE ? null : _react.default.createElement(_UIBox.default, {
        className: "action-button"
      }, _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        onClick: onEdit
      }, _react.default.createElement(_UIIcon.default, {
        name: "edit"
      }))))));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        onChange: _react.PropTypes.func.isRequired,
        onEdit: _react.PropTypes.func.isRequired
      };
    }
  }]);
  return GDPROptions;
}(_react.PureComponent);

exports.default = GDPROptions;
module.exports = exports.default;